import { API } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { PackageCheck } from "lucide-react";

const money = (value) => `₹${Number(value || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export function ProductCard({ product, onSelect }) {
  const image = product.images?.[0];
  const imageUrl = image ? `${API}/public/products/${product.id}/image/${image.file_id}` : null;
  return (
    <article
      className="product-card group cursor-pointer overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm"
      data-testid={`customer-product-card-${product.id}`}
      role="button"
      tabIndex={0}
      onClick={() => onSelect?.(product)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") onSelect?.(product);
      }}
    >
      <div className="aspect-[4/3] overflow-hidden bg-gray-100">
        {imageUrl ? (
          <img src={imageUrl} alt={product.name} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" loading="lazy" />
        ) : (
          <div className="flex h-full items-center justify-center text-gray-400"><PackageCheck className="h-10 w-10" /></div>
        )}
      </div>
      <div className="space-y-4 p-5">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <Badge className="border-emerald-200 bg-emerald-50 text-emerald-700">MOQ {product.moq} pcs</Badge>
            {product.category ? <Badge className="border-blue-200 bg-blue-50 text-blue-700">{product.category}</Badge> : null}
          </div>
          <h3 className="font-headline text-xl font-semibold text-gray-950">{product.name}</h3>
          <p className="mt-2 line-clamp-2 text-sm leading-6 text-gray-600">{product.description}</p>
        </div>
        <div className="flex flex-wrap gap-2">
          {(product.colors || []).slice(0, 4).map((color) => (
            <span key={color} className="rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-xs text-gray-600">{color}</span>
          ))}
        </div>
        <div className="flex items-end justify-between border-t border-gray-100 pt-4">
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-gray-500">Bulk price</div>
            <div className="font-headline text-2xl font-bold text-gray-950">{money(product.retail_price)}</div>
            <div className="text-xs text-gray-500">incl. GST{product.hsn_code ? ` · HSN ${product.hsn_code}` : ""}</div>
          </div>
          <div className="rounded-xl bg-blue-600 px-3 py-2 font-mono text-xs text-white">{product.public_sku}</div>
        </div>
      </div>
    </article>
  );
}
